/* eslint-disable no-unused-vars */
//This calls are necessary to generate public path which faceAPIUses
const faceLandmarkModel = require('../assets/models/face_landmark_68_tiny_model-weights_manifest.json');
const faceLandmarkModelShard = require('../assets/models/face_landmark_68_tiny_model-shard1.shard');
const tinyFaceDetectorModel = require('../assets/models/tiny_face_detector_model-weights_manifest.json');
const tinyFaceDetectorModelShard = require('../assets/models/tiny_face_detector_model-shard1.shard');
const faceExpressionsModel = require('../assets/models/face_expression_model-weights_manifest.json');
const faceExpressionsModelShard = require('../assets/models/face_expression_model-shard1.shard');
// Load models and weights
export async function loadModels() {
}

export async function getFullFaceDescription(blob, inputSize = 512) {
}

export function getEyeWidth(eyePoints) {
  const leftMorePoint = eyePoints.reduce((a, b) => {
    return a._x < b._x ? a : b;
  })._x;
  const rightMorePoint = eyePoints.reduce((a, b) => {
    return a._x > b._x ? a : b;
  })._x;
  return rightMorePoint - leftMorePoint;
}
